import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding-bottom: 4px;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  max-width: 100%;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  background-color: #eee;
  padding: 2px 8px;
  border-radius: 16px;
`;

export const RemoveTagButton = styled.button`
  margin-left: 4px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  padding: 0;
`;

export const Input = styled.input`
  border: none;
  outline: none;
  font-size: 14px;
  flex: 1 1 auto;
  min-width: 140px;

  &:hover {
    border: 1px solid #b2d47e;
  }
`;

export const Textarea = styled.textarea`
  border: none;
  outline: none;
  min-height: 160px;
  font-size: 14px;
  flex: 1 1 auto;
  min-width: 0;
  border: 1px solid rgba(144, 144, 144, 0.25);
  &:hover {
    border: 1px solid #b2d47e;
  }
`;
